






























import {Component, Watch, Vue} from 'vue-property-decorator';
import PlanShiftCount from './PlanEditShiftCount.vue';
import PlanShiftDaySchedule from './PlanEditShiftDaySchedule.vue';
import {mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';

@Component({
    components: {
        PlanShiftCount,
        PlanShiftDaySchedule,
    },
    computed: {
        ...mapState('planEdit', ['planEdit']),
    },
})
export default class PlanShift extends Vue {
    private panel: any = null;
    private panelReadonly: boolean = false;

    public planEdit!: PlanEditModel | null;
}
